import React, { useEffect, useRef } from 'react';
import { Chart, BarController, BarElement, LineController, LineElement, PointElement, CategoryScale, LinearScale, Legend, Tooltip, Filler, ArcElement } from 'chart.js';

Chart.register(BarController, BarElement, LineController, LineElement, PointElement, CategoryScale, LinearScale, Legend, Tooltip, Filler, ArcElement);

const academicFont = `'Noto Sans KR', 'Malgun Gothic', 'Apple SD Gothic Neo', 'Source Sans Pro', 'Segoe UI', sans-serif`;

export default function ChartRenderer({ spec }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    try {
      const ctx = canvasRef.current.getContext('2d');
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }

      const { type = 'bar', labels = [], datasets = [], options = {} } = spec || {};

      const baseOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
            labels: {
              font: { family: academicFont, size: 12 },
              color: '#4a5568'
            }
          },
          tooltip: {
            backgroundColor: '#1f2937',
            titleColor: '#f9fafb',
            bodyColor: '#e5e7eb',
            titleFont: { family: academicFont, size: 12, weight: '600' },
            bodyFont: { family: academicFont, size: 12 }
          }
        },
        scales: {
          x: {
            grid: { color: 'rgba(0,0,0,0.06)' },
            ticks: { font: { family: academicFont, size: 12 }, color: '#4a5568' }
          },
          y: {
            grid: { color: 'rgba(0,0,0,0.06)' },
            ticks: { font: { family: academicFont, size: 12 }, color: '#4a5568' }
          }
        },
        layout: { padding: 8 },
        ...options
      };

      chartRef.current = new Chart(ctx, {
        type,
        data: { labels, datasets },
        options: baseOptions
      });
    } catch (e) {
      // noop
    }

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [spec]);

  return (
    <div style={{ width: '100%', height: 320 }}>
      <canvas ref={canvasRef} />
    </div>
  );
}


